import React from "react";
import IconButton from "material-ui/IconButton";
import StarIcon from "material-ui/svg-icons/toggle/star";
import StarBorderIcon from "material-ui/svg-icons/toggle/star-border";
import { lighten } from "material-ui/utils/colorManipulator";

import WishlistActions from "../../actions/WishlistActions";

class StarButton extends React.Component {
  constructor(props) {
    super(props);
  }

  static get contextTypes() {
    return {
      muiTheme: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  render() {
    const { wishlisted, type, id } = this.props;
    const iconProps = { color: this.context.muiTheme.palette.accent1Color };

    if (!wishlisted) {
      iconProps.color = lighten(iconProps.color, 0.4);
    }

    return (
      <IconButton
        key="wishlist"
        tooltip={wishlisted ? "Unstar" : "Star"}
        tooltipStyles={{
          marginTop: 25,
          marginRight: 18,
          width: 46,
          zIndex: 99999
        }}
        tooltipPosition="top-left"
        className="eventive__wishlist-button"
        style={{
          verticalAlign: "middle",
          height: 24,
          width: 24,
          padding: 0,
          [this.context.isLarge || type === "films"
            ? "marginRight"
            : "marginLeft"]: 7,
          pointerEvents: "auto"
        }}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (wishlisted) {
            WishlistActions.remove({ id, type });
          } else {
            WishlistActions.add({ id, type });
          }
        }}
      >
        {wishlisted ? (
          <StarIcon {...iconProps} />
        ) : (
          <StarBorderIcon {...iconProps} />
        )}
      </IconButton>
    );
  }
}

export default StarButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/star-button.jsx